import React from "react";
import { SnippetReportSummaryFilters, SnippetReportSentence } from ".";
import { getFilterMap } from "./snippetReportSummaryUtils";

const SnippetReportSummary = React.forwardRef(
  (
    {
      selectedLocations,
      startDate,
      endDate,
      startBed,
      endBed,
      columns,
      total,
      selectedBedList,
    },
    ref,
  ) => {
    return (
      <div className="snippet-summary" ref={ref}>
        <SnippetReportSentence
          selectedLocations={selectedLocations}
          startDate={startDate}
          endDate={endDate}
          columns={columns}
          total={total}
          selectedBedList={selectedBedList}
        />
        <SnippetReportSummaryFilters
          filterMap={getFilterMap({
            columns,
            startBed,
            endBed,
          })}
        />
      </div>
    );
  },
);
export default SnippetReportSummary;
